/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadStatus = {
    Draft: 'DRAFT',
    Posted: 'POSTED',
    Booked: 'BOOKED',
    Transit: 'TRANSIT',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED'
} as const;
export type LoadStatus = typeof LoadStatus[keyof typeof LoadStatus];

